import Vue from 'vue';
import App from './App.vue';
import md5 from 'js-md5';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import GlobalJs from '@/assets/js/GlobalJs';
import Account from '@/assets/js/data/Account';
import * as echarts from 'echarts';
import XLSX from 'xlsx';
import VueSocketIO from 'vue-socket.io';
import store from './store';
import router from './router';
import './assets/element-#5DAF34/index.css' //更改页面主题颜色 element
import './assets/css/common.css'//全局样式表 -lily
//封装axios请求过程与后台api
import api from '@/api/requestApi'
import { post, get,} from '@/assets/js/network/network.js';
//定义全局变量
Vue.prototype.$api = api;
Vue.prototype.$post = post;
Vue.prototype.$get = get;
import VueCookies from 'vue-cookies'
// import 'babel-polyfill';
Vue.use(VueCookies)
Vue.use(XLSX);
Vue.prototype.echarts = echarts;
// Vue.prototype.VueSocketIO = VueSocketIO;
Vue.prototype.GlobalJs = GlobalJs;
Vue.prototype.Account = Account;
Vue.prototype.$md5 = md5;
Vue.config.productionTip = false;
Vue.use(ElementUI);
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});

router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
});
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
